'use client';

import { Provider } from 'react-redux';
import { store } from './store';
export function Providers({
  children
}: {
  children: React.ReactNode;
}) {
  return <Provider store={store} data-sentry-element="Provider" data-sentry-component="Providers" data-sentry-source-file="provider.tsx">{children}</Provider>;
}